import React from 'react'
import classNames from 'classnames'

import './Clickable.scss'

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement>{
  className?: string
  centered?: boolean
  withHover?: boolean
  alignBot?: boolean
  as?: 'div' | 'button'
}

const Clickable: React.FC<Props> = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const {children, centered, alignBot, className, withHover, as, ...rest} = props
  if (as === 'div') {
    // @ts-expect-error
    return <div ref={ref} onClick={rest.onClick} className={classNames('clickable', { centered, withHover, alignBot }, className)} >{children}</div>
  }
  return <button ref={ref} className={classNames('clickable', { centered, withHover, alignBot }, className)} type='button' {...rest}>{children}</button>
})

export default Clickable